
import { getCurrencySymbol } from '../intl/getCurrencySymbol';
import {
    getGreetingsPricePerCurrency,
    getGreetingsProviderCode,
    getGreetingsProviderToken,
    getGreetingsSupportedLocales
} from '../app/bootstrap';

export const isGreetingsSupported = (selectedLocale, selectedCurrency) => {
    const supportedLocales = getGreetingsSupportedLocales().split(',');
    let isLocaleSupported = false;
    let isCurrencySupported = false;

    if (supportedLocales) {
        isLocaleSupported = supportedLocales.includes(selectedLocale);
    }
    const greetingsPrices = getGreetingsPricePerCurrency();
    if (greetingsPrices && typeof greetingsPrices === 'object') {
        const supportedCurrencies = Object.keys(greetingsPrices);
        isCurrencySupported = supportedCurrencies.includes(selectedCurrency);
    }
    return isLocaleSupported && isCurrencySupported;
};

export const getGreetingsPrice = (selectedCurrency) => {
    const prices = getGreetingsPricePerCurrency();
    if (!prices || typeof prices !== 'object') {
        return null;
    }
    return prices[selectedCurrency] || null;
};
export const getAmountValue = (intl, selectedCurrency) => {
    const currencySymbol = getCurrencySymbol(intl, selectedCurrency);
    const price = getGreetingsPrice(selectedCurrency);
    return `${currencySymbol.prefix}${price}${currencySymbol.suffix}`;
};

export const formatSelectedGreetingOrder = (order, selectedCurrency) => {
    if (!order || typeof order !== 'object') {
        return null;
    }
    let customTexts = [];
    if (order.personalizations.descriptions) {
        customTexts = order.personalizations.descriptions.map(item => item.content);
    }

    return {
        token: order.token || '',
        customTexts,
        uyoUrl: order.personalizations.images[0] || '',
        cardFrontUrl: order.product.thumb || '',
        cardBackUrl: order.personalizations.images[1] || '',
        price: getGreetingsPrice(selectedCurrency),
        authToken: getGreetingsProviderToken(),
        provider: getGreetingsProviderCode(),
        meta: order
    };
};
